// Formatea con espacios (ejemplo: 1 55 1234 5678)
export const formattedPhone = (numbers) =>
    numbers.replace(/(\d{1})(\d{2})?(\d{4})?(\d{4})?/, (_, p1, p2, p3, p4) =>
        [p1, p2, p3, p4].filter(Boolean).join(' '),
    );

export const checkMissingKeys = (obj, requiredKeys) => {
    for (let key of requiredKeys) {
        if (!obj.hasOwnProperty(key)) {
            return true;
        }
    }
    return false;
};

// array de droguerias && numero minimo de droguerias
export const checkQuantityDrugManufacturers = (array: any[], number: number) => {
    const numericCount = array.filter((item) => !isNaN(Number(item))).length;
    return numericCount >= number;
};

/* recibe el array de droguerías y valida que exista "Otros" siempre y 
    cuando se seleccióno 1 o 2
    si se selecciono > 2 no valida */
export const includesOthers = (array: any[]) => {
    if (array.length === 1 && array[0] === 'Otros') {
        return true;
    }

    if (array.length === 2 && (array[0] === 'Otros' || array[1] === 'Otros')) {
        return true;
    }

    return false;
};
